// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"ca32a966f9454f876793","453":"f3345aff713d16979b2d","758":"924d0cd2d5ff47900844"}[chunkId] + ".js";
};